

























































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import SearchIcon from 'mdi-vue/Magnify';
import ExportIcon from 'mdi-vue/FileExportOutline';
import api, { apiSandbox } from '@/libs/api';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Select from '@/components/Select.vue';
import DatePicker from '@/components/DatePicker.vue';
import hasPermission from '@/libs/permission';
import Modal from '@/components/Modal.vue';
import AddIcon from 'mdi-vue/Plus';
import { MerchantsManagement, MerchantChannel, Bank } from '@/libs/api.interfaces';
import CloseIcon from 'mdi-vue/Close';
import { showToast } from '@/libs/toast';
import Toggle from '@/components/Toggle.vue';
import { ToastType } from '@/store/toast';
import numberFormat from '@/libs/numberFormat';
import Checkbox from '@/components/Checkbox.vue';
import FormInput from '@/components/FormInput.vue';
import Alto from '@/pages/MerchantLead/LeadTab/Form/Alto.vue';
import BayarindWeb from '@/pages/MerchantLead/LeadTab/Form/BayarindWeb.vue';
import BcaKlikPay from '@/pages/MerchantLead/LeadTab/Form/BcaKlikPay.vue';
import BcaSakuku from '@/pages/MerchantLead/LeadTab/Form/BcaSakuku.vue';
import BcaVirtualAccount from '@/pages/MerchantLead/LeadTab/Form/BcaVirtualAccount.vue';
import BniIpay from '@/pages/MerchantLead/LeadTab/Form/BniIpay.vue';
import BniSyariahVirtualAccount from '@/pages/MerchantLead/LeadTab/Form/BniSyariahVirtualAccount.vue';
import BniVirtualAccount from '@/pages/MerchantLead/LeadTab/Form/BniVirtualAccount.vue';
import BPDPay from '@/pages/MerchantLead/LeadTab/Form/BPDPay.vue';
import BriePay from '@/pages/MerchantLead/LeadTab/Form/BriePay.vue';
import BriVirtualAccount from '@/pages/MerchantLead/LeadTab/Form/BriVirtualAccount.vue';
import CIMBClick from '@/pages/MerchantLead/LeadTab/Form/CIMBClick.vue';
import DANA from '@/pages/MerchantLead/LeadTab/Form/DANA.vue';
import DanamonVirtualAccount from '@/pages/MerchantLead/LeadTab/Form/DanamonVirtualAccount.vue';
import Indodana from '@/pages/MerchantLead/LeadTab/Form/Indodana.vue';
import IndosatDompetku from '@/pages/MerchantLead/LeadTab/Form/IndosatDompetku.vue';
import KartuKredit from '@/pages/MerchantLead/LeadTab/Form/KartuKredit(DoAcquire).vue';
import KlikBCA from '@/pages/MerchantLead/LeadTab/Form/KlikBCA.vue';
import Kredivo from '@/pages/MerchantLead/LeadTab/Form/Kredivo.vue';
import MandiriClickPay from '@/pages/MerchantLead/LeadTab/Form/MandiriClickPay.vue';
import MandirieCash from '@/pages/MerchantLead/LeadTab/Form/MandirieCash.vue';
import MandiriVirtualAccount from '@/pages/MerchantLead/LeadTab/Form/MandiriVirtualAccount.vue';
import Maybank2You from '@/pages/MerchantLead/LeadTab/Form/Maybank2You.vue';
import MaybankVirtualAccount from '@/pages/MerchantLead/LeadTab/Form/MaybankVirtualAccount.vue';
import PermataVirtualAccount from '@/pages/MerchantLead/LeadTab/Form/PermataVirtualAccount.vue';
import ShopeePay from '@/pages/MerchantLead/LeadTab/Form/ShopeePay.vue';
import TCash from '@/pages/MerchantLead/LeadTab/Form/TCash.vue';
import UnionPay from '@/pages/MerchantLead/LeadTab/Form/UnionPay.vue';
import ArtaGrahaVirtualAccount from '@/pages/MerchantLead/LeadTab/Form/ArtaGrahaVirtualAccount.vue';
import Select2 from '@/components/Select2.vue';
import ModalPayment from './ModalPayment.vue';
import PaymentChannelTable from './PaymentTable.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    AddIcon,
    Header,
    SubHeader,
    Loader,
    Button,
    SearchIcon,
    ExportIcon,
    FormInput,
    DatePicker,
    SearchField,
    SearchRow,
    Select,
    Modal,
    PaymentChannelTable,
    ModalPayment,
    Checkbox,
    Alto,
    BayarindWeb,
    BcaKlikPay,
    BcaSakuku,
    BcaVirtualAccount,
    BniIpay,
    BniSyariahVirtualAccount,
    BniVirtualAccount,
    BPDPay,
    BriePay,
    BriVirtualAccount,
    CIMBClick,
    DANA,
    DanamonVirtualAccount,
    Indodana,
    IndosatDompetku,
    KartuKredit,
    KlikBCA,
    Kredivo,
    MandiriClickPay,
    MandirieCash,
    MandiriVirtualAccount,
    Maybank2You,
    MaybankVirtualAccount,
    PermataVirtualAccount,
    ShopeePay,
    TCash,
    UnionPay,
    ArtaGrahaVirtualAccount,
    CloseIcon,
    Toggle,
    Select2,
  },
  methods: {
    hasPermission,
  },
})
export default class PaymentChannel extends Vue {
  searchOpen = false;
  reseller = false;
  BusinessStatus = true;
  reason = '';
  status = '';
  description = '';
  loadingExport = false;
  loadingBank = false;
  bankOptions: { label: string; value: string }[] = []
  modalPayment = false;

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;
  loadingSubmit = false
  $refs!: {
    report: PaymentChannelTable;
  }

  // eslint-disable-next-line spaced-comment
  // channelCodes: { [key: string]: string[] } = {
  //   // 1072: ['Alto', 'Alto'],
  //   1022: ['BCA KlikPay', 'BcaKlikPay'],
  //   1024: ['BCA Sakuku', 'BcaSakuku'],
  //   1021: ['BCA Virtual Account', 'BcaVirtualAccount'],
  //   1041: ['BNI iPay', 'BniIpay'],
  //   1042: ['BNI Virtual Account', 'BniVirtualAccount'],
  //   1043: ['BNI Syariah Virtual Account', 'BniSyariahVirtualAccount'],
  //   1062: ['BRI Virtual Account', 'BriVirtualAccount'],
  //   1081: ['CIMB Click', 'CIMBClick'],
  //   1074: ['Danamon Virtual Account', 'DanamonVirtualAccount'],
  //   1061: ['BRI ePay', 'BriePay'],
  //   // 1071: ['Indosat Dompetku', 'IndosatDompetku'],
  //   2001: ['Kartu Kredit (DoAcquire)', 'KartuKredit'],
  //   2002: ['Kartu Kredit (PCS)', 'KartuKreditPCS'],
  //   1023: ['KlikBCA', 'KlikBCA'],
  //   1073: ['Kredivo', 'Kredivo'],
  //   // 1031: ['Mandiri eCash', 'MandirieCash'],
  //   1032: ['Mandiri Bill Payment', 'MandiriVirtualAccount'],
  //   // 1051: ['Maybank 2 you', 'Maybank2You'],
  //   1052: ['Maybank Virtual Account', 'MaybankVirtualAccount'],
  //   1011: ['Permata Virtual Account/Net', 'PermataVirtualAccount'],
  //   // 9999: ['Mandiri ClickPay', 'MandiriClickPay'],
  //   1077: ['TCASH', 'TCash'],
  //   // 9998: ['BPDPay', 'BPDPay'],
  //   // 1082: ['UnionPay', 'UnionPay'],
  //   1080: ['Indodana', 'Indodana'],
  //   1083: ['Bayarind Web', 'BayarindWeb'],
  //   1084: ['DANA', 'DANA'],
  //   1085: ['ShopeePay', 'ShopeePay'],
  //   1078: ['Homecredit', 'Homecredit'],
  //   9001: ['Onepay', 'Onepay'],
  //   9002: ['Easy Invoice', 'Easyinvoice'],
  //   1101: ['Arta Graha Virtual Account', 'ArtaGrahaVirtualAccount'],
  //   // 1012: ['Permata Net', 'Permatanet'],
  // }

  channelCodes: any = [];
  listChannel: string[] = [];
  listComponent: { [key: string]: string } = {};
  channel: any = [];
  channelWhenOpened = '';
  channelComponent = '';
  autoGenerate = true;
  showSelect = false;
  channelSelect = false;
  mcode = '';
  channelInput = '';
  channelID = '';
  showModal = false;
  data!: MerchantsManagement;
  channellist: MerchantChannel[] = [];
  numberFormat!: typeof numberFormat;

  @Watch('channel')
  onChannelChange() {
    this.channelComponent = this.listComponent[this.channel];
  }

  @Watch('BusinessStatus')
  BussinesStatusChane() {
    this.reason = '';
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  close(val: any) {
    this.showModal = val;
  }

  toggleModal() {
    this.showModal = true;
    this.getPaymentChannel();
  }

  format!: (val: string) => string;
  hasPermission!: (val: string) => boolean;

  mounted() {
    this.parseParams();
    this.getStatus();
    const { channels, components } = Object.entries(this.channelCodes).reduce((prev, curr) => {
      const last = prev;
      // const [code, comp] = curr[1];
      // last.channels.push(code);
      // last.components[code] = comp;

      return last;
    }, {
      channels: [] as string[],
      components: {} as { [key: string]: string },
    });
    this.listChannel = channels;
    this.listComponent = components;
    this.$refs.report.secretKey = this.$parent.$data.secretKey;
    // this.getBanks();
  }

  async getBanks() {
    try {
      this.loadingBank = true;
      const { data } = await apiSandbox.get<Bank[]>('/bank');
      const banks = data[0];
      this.bankOptions = Object.entries(banks).map((e) => ({ label: e[1], value: e[0] }));
      this.loadingBank = false;
    } catch (err) {
      showToast(ToastType.FAILED, 'Error', 'Failed to load bank list');
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async getDisbursment(isExport = false, page: number) {
    const params = {
      status: this.status,
    };

    if (isExport) {
      await this.$refs.report.export(params);
    } else {
      await this.$refs.report.getDisbursment(params, false, page);
    }
  }

  async getStatus() {
    try {
      const { data } = await apiSandbox.get(`/consumer/channel/${this.$route.params.type}`);
      this.BusinessStatus = data.status === 1;
      this.reseller = data.is_resseller === 1;
      this.reason = data.status_reason;
    } catch (error) {
      console.log(error);
    }
  }

  async submitStatus() {
    try {
      const { data } = await apiSandbox.post(`consumer/channel/${this.$route.params.type}`, {
        status: this.BusinessStatus ? 1 : 0,
        /* eslint-disable @typescript-eslint/camelcase */
        is_reseller: this.reseller ? 1 : 0,
        reason: this.reason,
      });

      try {
        await api.post(`consumer/channel/${this.$route.params.type}`, {
          status: this.BusinessStatus ? 1 : 0,
          /* eslint-disable @typescript-eslint/camelcase */
          is_reseller: this.reseller ? 1 : 0,
          copy_from_sandbox: true,
          reason: this.reason,
        });
        showToast(ToastType.SUCCESS, 'Success', 'Congrats, your changes have been saved');
      } catch (error) {
        showToast(ToastType.FAILED, 'Error', error.response.data.message);
      }
      this.$router.push('/merchant-lead');
    } catch (error) {
      showToast(ToastType.FAILED, 'Error', error.response.data.message);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async getPaymentChannel() {
    try {
      const { data } = await apiSandbox.get('listPaymentChannel');
      // eslint-disable-next-line max-len
      // console.log(data.map((e: any) => (e.map((d: any) => (this.channel.push({ label: d.name, value: d.service_code }))))));
      // console.log(this.channel);
      // data.forEach((e: any) => { console.log(e); });
      Object.keys(data).forEach((e: any) => {
        data[e].map((a: any) => (this.channelCodes.push({ label: a.name, value: a.service_code })));
      });
    } catch (error) {
      showToast(ToastType.FAILED, 'Error', error.response.data.message);
    }
  }

  async addPayment() {
    try {
      this.loadingSubmit = true;
      const code: any = [];
      this.channel.map((e: any) => (code.push(e.value)));

      await apiSandbox.post('merchant/payment-channel', {
        /* eslint-disable @typescript-eslint/camelcase */
        merchant_code: this.$route.params.type,
        service_code: code,
      });
      showToast(ToastType.SUCCESS, 'Success Create Channel', 'Congrats, your changes have been saved');
      this.parseParams();
      this.loadingSubmit = false;
      this.close(false);
    } catch (error) {
      this.loadingSubmit = false;
      showToast(ToastType.FAILED, 'Error', error.response.data.messsage);
      this.close(false);
    }
  }

  parseParams() {
    const params = this.$route.query;

    let page = 1;
    if (typeof params.page === 'string') {
      page = Number(params.page);
    }

    this.getDisbursment(false, page);
  }

  async exportData() {
    this.loadingExport = true;
    await this.getDisbursment(true, 1);
    this.loadingExport = false;
  }
}
